var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ sphere: true, visible: _vm.visible, hidden: (_vm.empty || !_vm.sphereVisible) }},[_c('canvas',{ref:"canvas",staticClass:"sphere__canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }